import { ApprovalPage } from '@/pages/anchor-management/approval'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_app/p/anchor-management/anchor-approval'
)({
	component: ApprovalPage,
})
